module.exports = "mutation CancelPausedRecipients($recipientIds: [ID!]) {\n  cancelPausedRecipients(recipientIds: $recipientIds) {\n    success\n  }\n}\n"